import 'EventLogger/angularModule';

export default angular.module('FrontRoyalTimer', ['EventLogger']);
